import angular from 'angular';
/**
 * appends all rendered modals to the body where they are in the right stacking context.
 */
export const moveModals = () => {
  angular.element(document).ready(function () {
    // Find the modal element (adjust selector if needed)
    var modals = document.querySelectorAll('ngeo-modal > .modal');
    console.log('modal', modals);
    modals.forEach(function (modal) {
      if (modal && modal.parentNode !== document.body) {
        document.body.appendChild(modal);
      }
    });
  });
};
